import React, { useState, useEffect } from "react";
import styled from "styled-components";

const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #eef1f4;
`;

const CarouselImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

const Indicators = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 12px;
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 6px 12px;
  pointer-events: none;
  z-index: 2;
`;

const IndicatorsPill = styled.div`
  display: inline-flex;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(20, 25, 30, 0.45);
  border-radius: 999px;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
`;

const Indicator = styled.button`
  width: 10px;
  height: 10px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background-color: ${(props) =>
    props.$active ? "#db3a34" : "rgba(255, 255, 255, 0.75)"};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  pointer-events: auto;
  transition: background-color 0.25s ease, transform 0.2s ease;

  &:hover {
    transform: scale(1.15);
  }
`;

const Placeholder = styled.div`
  width: 100%;
  aspect-ratio: 16 / 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef1f4;
  color: #9aa3ab;
  font-size: 13px;
  font-weight: 500;
`;

const ImageCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (images.length === 0) return;

    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 15000);

    return () => clearInterval(intervalId);
  }, [images]);

  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  if (images.length === 0) {
    return <Placeholder>Sin anuncios</Placeholder>;
  }

  return (
    <CarouselContainer>
      <CarouselImage
        src={images[currentIndex]}
        alt={`Carousel image ${currentIndex}`}
      />
      <Indicators>
        <IndicatorsPill>
          {images.map((_, index) => (
            <Indicator
              key={index}
              $active={index === currentIndex}
              onClick={() => handleIndicatorClick(index)}
              aria-label={`Mostrar anuncio ${index + 1}`}
            />
          ))}
        </IndicatorsPill>
      </Indicators>
    </CarouselContainer>
  );
};

export default ImageCarousel;
